<template>
  <div>
    <telegram-integration v-if="canManageTelegram"></telegram-integration>
    <div class="font-size-13 text-disabled mb-4">
      Оберіть канали, на які ви хочете отримувати сповіщення про різні події в
      системі. Глобальні перемикачі пошти та Telegram у загальній інформації
      мають пріоритет над цими налаштуваннями.
    </div>

    <v-data-table
      :headers="headers"
      :hide-default-footer="true"
      :items="notificationSettings"
      :items-per-page="-1">
      <template #item.title="{ item }">
        <div>{{ item.title }}</div>
        <div class="text-disabled font-size-12">
          {{ item.description }}
        </div>
      </template>
      <template #item.inApp="{ item }">
        <div class="d-flex justify-center">
          <v-switch
            v-model="item.inApp"
            :readonly="!canEditNotifications"
            color="primary"
            hide-details
            inset />
        </div>
      </template>
      <template #item.email="{ item }">
        <div class="d-flex justify-center">
          <v-switch
            v-model="item.email"
            :readonly="!canEditNotifications"
            color="primary"
            hide-details
            inset />
        </div>
      </template>
      <template #item.telegram="{ item }">
        <div class="d-flex justify-center">
          <v-switch
            v-model="item.telegram"
            :readonly="!canEditNotifications"
            color="primary"
            hide-details
            inset />
        </div>
      </template>
      <template #bottom></template>
    </v-data-table>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useUserCardStore } from '@/dialog/components/user-card/store'
import { useUserCardNotificationsStore } from '@/dialog/components/user-card/tabs/notifications/notifications'
import TelegramIntegration from '@/dialog/components/user-card/components/TelegramIntegration.vue'

export default {
  name: 'UserCardNotifications',
  components: { TelegramIntegration },
  setup() {
    const headers = ref([
      { key: 'title', title: 'Подія' },
      { key: 'inApp', title: 'В системі', align: 'center' },
      { key: 'email', title: 'Пошта', align: 'center' },
      { key: 'telegram', title: 'Telegram', align: 'center' },
    ])

    return {
      ...useUserCardStore(),
      ...useUserCardNotificationsStore(),
      headers,
    }
  },
}
</script>
